import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class OnboardingService {
    private readonly STORAGE_KEY = 'onboardingStatus';
    private initialized$ = new BehaviorSubject<boolean>(false);
    onboardingStatusValue = new BehaviorSubject<string | null>(null);

    constructor(private storageService: StorageService) {
        this.initializeOnboardingStatus();
    }

    private initializeOnboardingStatus() {
        this.migrateOldLocalStorageData();

        this.storageService.getItem<string>(this.STORAGE_KEY).subscribe({
            next: (value) => {
                this.onboardingStatusValue.next(value);
                this.initialized$.next(true);
            },
            error: (error) => {
                console.warn('Failed to load onboarding status:', error);
                this.onboardingStatusValue.next(null);
                this.initialized$.next(true);
            }
        });
    }

    private migrateOldLocalStorageData() {
        try {
            const oldValue = localStorage.getItem(this.STORAGE_KEY);
            if (oldValue && oldValue !== 'null' && oldValue !== 'undefined') {
                try {
                    JSON.parse(oldValue);
                } catch {
                    console.log('Migrating old onboarding status data');
                    localStorage.removeItem(this.STORAGE_KEY);
                }
            }
        } catch (error) {
            console.warn('Error during localStorage migration:', error);
        }
    }

    get initialized(): Observable<boolean> {
        return this.initialized$.asObservable();
    }

    set onboardingStatus(value: string) {
        this.onboardingStatusValue.next(value);
        this.storageService.setItem(this.STORAGE_KEY, value).subscribe({
            error: (error) => {
                console.warn('Failed to save onboarding status:', error);
            }
        });
    }

    get onboardingStatus(): string | null {
        return this.onboardingStatusValue.value;
    }
}
